module.exports = __webpack_public_path__ + "img/U型悬臂箱.2301d354.jpg";